import styles from './projects.module.css'

import ProjectItem from '../projectItem/ProjectItem'
import data from './projects.data'

const Project = () => {

    return(
        <div className={styles.container}>
        {
            data.map(item =>{
                return (
                    <ProjectItem key={item.id} projectItem={item}/>
                )
            })
        }
        </div>
    )
}

export default Project;